<template>
  <div class="attachments">
    <div class="title">
      附件说明
    </div>
    <div class="btn-group">
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary" class="upload-btn" :loading="loading">
          上传合同
        </el-button>
      </el-upload>
      <el-button type="default" class="mr8 download-btn" @click="downFiles">
        下载合同
      </el-button>
    </div>
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="left"
          fixed="left"
        />
        <el-table-column
          prop="fileName"
          label="文件名称"
          align="left"
          fixed="left"
        >
          <template slot-scope="scope">
            <el-button type="text" style="margin-left: 10px" class="show-one-line" @click="openContract(scope.row.fileCode)">
              {{ scope.row.fileName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdBy"
          label="上传人"
          align="left"
        />
        <el-table-column
          prop="createdTime"
          label="上传时间"
          show-overflow-tooltip
          align="left"
        />
        <el-table-column
          prop="updatedTime"
          label="最后更新时间"
          show-overflow-tooltip
          align="left"
        />
        <el-table-column label="操作" align="left" fixed="right">
          <template slot-scope="scope">
            <el-popconfirm
              title="确定删除该文件吗？"
              @confirm="handleDelete(scope.$index, scope.row)"
            >
              <el-link
                slot="reference"
                :underline="false"
                type="primary"
                class="fz-12"
              >
                删除
              </el-link>
            </el-popconfirm>
            <el-link
              :underline="false"
              type="primary"
              class="ml-16 fz-12"
              @click="downOneFile(scope.row)"
            >
              下载
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>
<script>
import AxiosApi from '@/API/fileAxios';
import {
  attachmentGetToken,
  uploadFile,
  getUrlByFileID,
  getTokenForDownZip
} from '@/API';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      multipleSelection: [],
      fileserveDownUrl: '',
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      loading: false
    };
  },
  components: {},
  mounted () {
    this.initToken();
  },
  methods: {
    // 删除附件
    handleDelete (index, row) {
      this.tableData.splice(index, 1);
    },
    // 多选
    handleSelectionChange (val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 多选下载
    downFiles () {
      if (!this.multipleSelection.length) {
        this.$notify({
          title: '请至少选择一个文件',
          type: 'warning'
        });
        return;
      }
      if (this.multipleSelection.length === 1) {
        this.downOneFile(this.multipleSelection[0]);
      } else {
        let fileIds = [];
        this.multipleSelection.forEach((item) => {
          fileIds.push(item.fileCode);
        });
        getTokenForDownZip({
          catalogName: '回执单附件集合',
          fileIds
        }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.downzipFile(json.data.token, json.data.downloadZipUrl);
          }
        }).catch(() => {

        });
      }
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    // 附件下载
    downOneFile (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileCode}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    // 查看合同附件详情
    openContract (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    },
    // 合同附件上传成功后保存信息到数据库
    submitfile (files) {
      this.loading = true;
      uploadFile(files).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData.push(json.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    checkSpecialCharacters (str) {
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    // 获取token
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    // 上传文件
    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      this.loading = true;
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.submitfile({
            fileName: json.data[0].FullName,
            fileCode: json.data[0].FID
          });
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.attachments{
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title{
    color: #383838;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .btn-group{
    margin-bottom: 12px;
    ::v-deep .el-button{
      font-size: 14px;
      border-radius: 4px;
    }
  }
}
.mr8{
  margin-right: 8px;
}
.ml-16{
  margin-left: 16px;
}
.fz-12{
  font-size: 12px;
}
</style>
